import { tw } from '../../tailwind-types'

export const linkBtnClasses = tw(
  'inline-flex',
  'items-center',
  'px-2.5',
  'py-1.5',
  'border',
  'border-transparent',
  'text-xs',
  'leading-4',
  'font-medium',
  'rounded',
  'text-indigo-700',
  'bg-indigo-100',
  'hover:bg-indigo-50',
  'focus:outline-none',
  'focus:border-indigo-300',
  'focus:shadow-outline-indigo',
  'active:bg-indigo-200',
  'transition',
  'ease-in-out',
  'duration-150',
)
